<div class="product-picker-search-criteria-wrapper">
  <div class="product-picker-search-criteria-row space-between-elements" (keydown.enter)="search.emit()">
    <div
      class="field-wrapper max-error-width-small"
      *ngIf="filter.Filter?.PurchaseOrRemortgageCode === referenceDataLabels.RemortgageId"
    >
      <boi-numeric-input
        name="ProductPickerPropertyValue"
        [(ngModel)]="filter.RemortgageEstimatedPropertyValue"
        [min]="0"
        [labelName]="referenceDataLabels.ProductPickerPropertyValue"
        (ngModelChange)="computeLTV(); searchCriteriaChange.emit()"
        [validationErrors]="validationErrors"
        [validationPropertyNames]="['RemortgageEstimatedPropertyValue']"
        [autoCorrect]="true"
        [format]="'#'"
        [maxLength]="7"
        [cssClasses]="'label-top label-weight-bold label-font-size-13 product-value-field increase-label-line-height'"
      >
      </boi-numeric-input>
    </div>

    <div
      class="field-wrapper max-error-width-small"
      *ngIf="filter.Filter?.PurchaseOrRemortgageCode === referenceDataLabels.PurchaseId"
    >
      <boi-numeric-input
        name="ProductPickerPurchasePropertyPrice"
        [(ngModel)]="filter.PurchasePropertyPrice"
        [min]="0"
        [labelName]="referenceDataLabels.ProductPickerPurchasePropertyPrice"
        (ngModelChange)="computeLTV(); searchCriteriaChange.emit()"
        [validationErrors]="validationErrors"
        [validationPropertyNames]="['PurchasePropertyPrice']"
        [autoCorrect]="true"
        [format]="'#'"
        [maxLength]="7"
        [cssClasses]="
          'label-top label-weight-bold label-font-size-13 product-price-field currency-symbol increase-label-line-height'
        "
      >
      </boi-numeric-input>
    </div>

    <div class="field-wrapper max-error-width-small">
      <boi-numeric-input
        name="ProductPickerBorrowAmount"
        [(ngModel)]="filter.LoanAmount"
        [min]="0"
        [labelName]="referenceDataLabels.ProductPickerBorrowAmount"
        (ngModelChange)="computeLTV(); updateRepaymentPart(); searchCriteriaChange.emit()"
        [validationErrors]="validationErrors"
        [validationPropertyNames]="['LoanAmount']"
        [autoCorrect]="true"
        [format]="'#'"
        [maxLength]="7"
        [cssClasses]="
          'label-top label-weight-bold label-font-size-13 product-borrow-amount-field currency-symbol increase-label-line-height'
        "
      >
      </boi-numeric-input>
    </div>

    <div class="field-wrapper">
      <boi-numeric-input
        name="ProductPickerLTV"
        [(ngModel)]="filter.Ltv"
        (ngModelChange)="searchCriteriaChange.emit()"
        [labelName]="referenceDataLabels.ProductPickerLTV"
        [format]="'#'"
        [isFieldDisabled]="true"
        [cssClasses]="'label-top label-weight-bold label-font-size-13 product-ltv-field percent-symbol'"
      >
      </boi-numeric-input>
    </div>

    <div class="field-wrapper max-error-width-large">
      <boi-term-input
        [labelName]="referenceDataLabels.ProductPickerMortgageTerm"
        [(years)]="filter.LoanTermYears"
        (yearsChange)="searchCriteriaChange.emit()"
        [(months)]="filter.LoanTermMonths"
        (monthsChange)="searchCriteriaChange.emit()"
        [validationPropertyNames]="['LoanTermYears', 'LoanTermMonths']"
        [validationErrors]="validationErrors"
        [cssClasses]="'label-top label-weight-bold label-font-size-13 increase-label-line-height'"
      >
      </boi-term-input>
    </div>

    <div class="field-wrapper max-error-width-large">
      <boi-drop-down
        [labelName]="referenceDataLabels.ProductPickerRepaymentMethod"
        [optionList]="referenceDataOptionLists.RepaymentType"
        name="ProductPickerRepaymentMethod"
        [ngModel]="filter.RepaymentTypeCode"
        (ngModelChange)="repaymentTypeCodeChange($event); searchCriteriaChange.emit()"
        [textField]="'Value'"
        [valueField]="'Code'"
        [defaultItem]="{ Value: referenceDataLabels.PleaseSelect | localizeLabel, Code: undefined }"
        [validationErrors]="validationErrors"
        [validationPropertyNames]="['RepaymentTypeCode']"
        [cssClasses]="
          'label-top label-weight-bold label-font-size-13 product-repayment-type-field increase-label-line-height'
        "
      >
      </boi-drop-down>
    </div>
  </div>
  <div class="product-picker-search-criteria-row">
    <ng-container *ngIf="filter.RepaymentTypeCode === referenceDataOptionLists.RepaymentTypePartAndPart">
      <div class="field-wrapper max-error-width-small">
        <boi-numeric-input
          name="ProductPickerInterest"
          [(ngModel)]="filter.InterestOnlyPart"
          [min]="0"
          [labelName]="referenceDataLabels.ProductPickerInterest"
          (ngModelChange)="updateRepaymentPart(); searchCriteriaChange.emit()"
          [validationErrors]="validationErrors"
          [validationPropertyNames]="['InterestOnlyPart']"
          [autoCorrect]="true"
          [format]="'#'"
          [maxLength]="7"
          [cssClasses]="'label-top label-weight-bold label-font-size-13 product-interest-field currency-symbol'"
        >
        </boi-numeric-input>
      </div>
      <div class="field-wrapper max-error-width-small">
        <boi-numeric-input
          name="ProductPickerRepayment"
          [(ngModel)]="filter.RepaymentPart"
          (ngModelChange)="searchCriteriaChange.emit()"
          [labelName]="referenceDataLabels.ProductPickerRepayment"
          [isFieldDisabled]="true"
          [format]="'#'"
          [cssClasses]="
            'label-top label-weight-bold label-font-size-13 product-repayment-field currency-symbol increase-label-line-height'
          "
        >
        </boi-numeric-input>
      </div>
    </ng-container>

    <div
      class="flex-start-field field-wrapper max-error-width-large"
      *ngIf="filter.Filter?.PurchaseOrRemortgageCode === referenceDataLabels.PurchaseId"
    >
      <boi-radio-button-group
        [labelName]="referenceDataLabels.ProductPickerConcessionaryPrice"
        [ngModel]="filter.PurchasingAtConcessionaryPriceCode"
        (ngModelChange)="purchasingAtConcessionaryPriceCodeChange($event); searchCriteriaChange.emit()"
        [validationErrors]="validationErrors"
        [validationPropertyNames]="['PurchasingAtConcessionaryPriceCode']"
        [optionList]="referenceDataOptionLists.AnswerType"
        [isTooltipLast]="false"
        [cssClasses]="'label-left label-weight-bold label-font-size-13 row-options'"
      >
      </boi-radio-button-group>
    </div>

    <div
      class="field-wrapper max-error-width-small"
      *ngIf="filter.PurchasingAtConcessionaryPriceCode === referenceDataOptionLists.AnswerTypeYes"
    >
      <boi-numeric-input
        name="ProductPickerTrueMarketValue"
        [(ngModel)]="filter.TrueMarketPrice"
        [min]="0"
        [labelName]="referenceDataLabels.ProductPickerTrueMarketValue"
        (ngModelChange)="computeLTV()"
        [validationErrors]="validationErrors"
        [validationPropertyNames]="['TrueMarketPrice']"
        [autoCorrect]="true"
        [format]="'#'"
        [maxLength]="7"
        (ngModelChange)="searchCriteriaChange.emit()"
        [cssClasses]="'label-top label-weight-bold label-font-size-13 product-market-value-field currency-symbol'"
      >
      </boi-numeric-input>
    </div>

    <div class="flex-start-field field-wrapper max-error-width-small">
      <boi-checkbox
        [(ngModel)]="filter.ArrangementFeeIncludedCode"
        (ngModelChange)="searchCriteriaChange.emit()"
        [trueValue]="referenceDataOptionLists.AnswerTypeYes"
        [falseValue]="referenceDataOptionLists.AnswerTypeNo"
        [checkboxLabel]="referenceDataLabels.ProductPickerIncludeArrangment | localizeLabel"
        [tooltipName]="referenceDataLabels.ProductPickerIncludeArrangment"
        name="arrangementFeeIncludedCode"
        [controlId]="'arrangementFeeIncludedCode'"
        [cssClasses]="'label-top label-weight-bold label-font-size-13 product-arrangement-fee-field'"
      >
      </boi-checkbox>
    </div>

    <div class="field-wrapper max-error-width-large">
      <boi-drop-down
        [labelName]="referenceDataLabels.ProductEPCRating"
        [availableOptions]="EPCRatingOptionList"
        name="ProductEPCRating"
        [isTooltipLast]="false"
        [isFieldDisabled]="isEpcRatingFieldDisabled"
        [(ngModel)]="filter.PropertyEPCRatingCode"
        (ngModelChange)="epcRatingChange($event); searchCriteriaChange.emit()"
        [textField]="'Value'"
        [valueField]="'Code'"
        [defaultItem]="{ Value: referenceDataLabels.PleaseSelect | localizeLabel, Code: undefined }"
        [validationErrors]="validationErrors"
        [validationPropertyNames]="['PropertyEPCRatingCode']"
        [cssClasses]="
          'label-top label-weight-bold label-font-size-13 product-epc-rating-field increase-label-line-height'
        "
      >
      </boi-drop-down>
    </div>

    <div *ngIf="displayEPCDateIssued()" class="field-wrapper max-error-width-large product-picker-date">
      <boi-generic-date-input
        [labelName]="referenceDataLabels.ProductEPCRatingDateIssued"
        [tooltipName]="referenceDataLabels.ProductEPCRatingDateIssued"
        [isFieldDisabled]="isEpcDateIssuedDisabled"
        [(value)]="filter.EPCDateIssued"
        [validationErrors]="validationErrors"
        [validationPropertyNames]="['EPCDateIssued']"
        [cssClasses]="
          'label-top label-weight-bold label-font-size-13 product-epc-rating-field increase-label-line-height'
        "
      ></boi-generic-date-input>
    </div>
  </div>

  <div class="product-picker-search-criteria-btns">
    <button
      class="primary-button mr-12"
      [innerHtml]="referenceDataLabels.ProductPickerReset | localizeLabel"
      (click)="clearFilters.emit()"
    ></button>
    <button
      class="secondary-button"
      [innerHtml]="referenceDataLabels.ProductPickerUpdate | localizeLabel"
      (click)="search.emit()"
    ></button>
  </div>
</div>
